module.exports = __webpack_public_path__ + "fonts/65e57733b0a20cfe98181f7ead075846.svg";